
import * as React from 'react';

import {Box as MaterialBox }from '@mui/material';
import { Alert as MaterialAlert } from '@mui/material';
import { IconButton as MaterialIconButton } from '@mui/material';
import { Collapse as MaterialCollapse } from '@mui/material';
import {Close as MaterialCloseIcon} from '@mui/icons-material';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';

export const AlertMessage: React.FC = () => {

  const [open, setOpen] = React.useState<boolean>(false);
  const [message, setMessage] = React.useState();
  const [severity, setSeverity] = React.useState();

  React.useEffect(() => {
    const listener = (props1,props2,props3,props4) => {
      setMessage(props1)
      setSeverity(props2)
      setOpen(props3)
      if (props4 == true) {
        setTimeout(() => {
          setOpen(false);
        }, 4000);  
      }
    };
    apiProvider.on(Event.visualizerSettingsAlert, listener);
    apiProvider.on(Event.uploadFileAlert, listener);
    apiProvider.on(Event.variantFilterAlert, listener);
    apiProvider.on(Event.stepFilterAlert, listener);
    apiProvider.on(Event.pathFilterAlert, listener);
    apiProvider.on(Event.activityFilterAlert, listener);
    apiProvider.on(Event.attributeFilterAlert, listener);
    apiProvider.on(Event.timeFilterAlert, listener);

    apiProvider.on(Event.discoveryConstraintAlert, listener);

    return () => {
        apiProvider.off(Event.visualizerSettingsAlert, listener);
        apiProvider.off(Event.uploadFileAlert, listener);
        apiProvider.off(Event.variantFilterAlert, listener);
        apiProvider.off(Event.stepFilterAlert, listener);
        apiProvider.off(Event.pathFilterAlert, listener);
        apiProvider.off(Event.activityFilterAlert, listener);
        apiProvider.off(Event.attributeFilterAlert, listener);
        apiProvider.off(Event.timeFilterAlert, listener);
        
        apiProvider.off(Event.discoveryConstraintAlert, listener);

    };
  }, []);

  return (
    <MaterialBox sx={{ width: '100%' }}>
      <MaterialCollapse in={open}>
        <MaterialAlert
          severity={severity}
          action={
            <MaterialIconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
            <MaterialCloseIcon fontSize="inherit" />
            </MaterialIconButton>
          }
          sx={{ mb: 2 }}
        >
        {message}
        </MaterialAlert>
      </MaterialCollapse>
    </MaterialBox>
  );
};
